import { render, staticRenderFns } from "./resultat-biochimie.html?vue&type=template&id=4a8e073d&scoped=true&external"
import script from "./resultat-biochimie.js?vue&type=script&lang=js&external"
export * from "./resultat-biochimie.js?vue&type=script&lang=js&external"
import style0 from "./resultat-biochimie.scss?vue&type=style&index=0&id=4a8e073d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8e073d",
  null
  
)

export default component.exports